// @spec AI-STR-011
// Policy compliance scans list page

import { createFileRoute } from '@tanstack/react-router';

import { PolicyScanPage } from '@/features/ai/scans';

export const Route = createFileRoute('/_authenticated/ai/scans/')({
  component: PolicyScansIndexPage,
});

function PolicyScansIndexPage() {
  return <PolicyScanPage />;
}
